export default __webpack_public_path__ + "static/digital-fintech-software-solution-1b9e15022799e8d36c812c1937c15767.png";